const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    style: {
      enableBackground: "new 0 0 28 28"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M17.7,23.6c-0.7-0.3-1.5,0-1.8,0.6c-0.2,0.4-0.5,0.7-0.8,0.9c-0.3,0.2-0.7,0.3-1.1,0.3 c-0.4,0-0.8-0.1-1.1-0.3c-0.3-0.2-0.6-0.5-0.8-0.9c-0.3-0.7-1.1-1-1.8-0.7c-0.7,0.3-1,1.1-0.7,1.7c0.4,0.8,1,1.5,1.7,2 c0.8,0.5,1.6,0.8,2.6,0.8c0,0,0,0,0.1,0c0.9,0,1.8-0.2,2.5-0.7c0.8-0.5,1.4-1.1,1.8-2C18.7,24.7,18.4,23.9,17.7,23.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M26.1,13.9c-1.1-1.1-1.6-1.9-1.6-2.6V9.7C24.5,4,19.8,0,14,0v0c0,0,0,0,0,0c0,0,0,0,0,0v0 C8.2,0,3.5,4,3.5,9.7v1.6c0,0.7-0.5,1.5-1.6,2.6C0.7,15.1,0,16.8,0,18.6c0,1.9,1.6,3.4,3.5,3.4h1.8H14h0h8.7h1.8 c1.9,0,3.5-1.5,3.5-3.4C28,16.8,27.3,15.1,26.1,13.9z M22.7,19.5h-2H14h0H7.3h-2c-1.5,0-2.3-0.8-2.1-2c0.2-1.3,1.2-2.3,2.1-3.3 c0.8-0.9,1-1.2,1.1-2.4V10c0-4.3,3.3-7.4,7.7-7.4c4.4,0,7.7,3.1,7.7,7.4v1.7c0.1,1.2,0.3,1.5,1.1,2.4c0.9,1,1.9,2,2.1,3.3 C25,18.6,24.2,19.5,22.7,19.5z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.c33ddb6485cd56eb406f236aed18f761.svg";
export { ForwardRef as ReactComponent };